"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldEditor = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var image_button_1 = require("../../../components/button/image.button");
var icon_1 = require("../../../components/icon");
var icons_1 = require("../../../components/icon/icons");
var input_1 = require("../../../components/input/input");
var input_checkbox_1 = require("../../../components/input/input.checkbox");
var input_state_group_1 = require("../../../components/input/input.state.group");
var menu_1 = require("../../../components/menu/menu");
var menu_item_1 = require("../../../components/menu/menu.item");
var modal_service_1 = require("../../../components/modal/modal.service");
var notification_service_1 = require("../../../components/notification.toast/notification.service");
var theme_1 = require("../../../components/theme");
var i18n_1 = require("../../../i18n");
var mithril_1 = require("../../../mithril");
var services_1 = require("../../../services");
var form_field_lock_1 = require("../form.field.lock");
var form_palette_1 = require("../form.palette");
var form_field_tree_view_1 = require("./form.field.tree.view");
var form_info_panel_style_1 = require("./form.info.panel.style");
(0, theme_1.addStyles)(form_info_panel_style_1.Style);
var FormFieldEditor = /** @class */ (function () {
    function FormFieldEditor(designer, field) {
        var _this = this;
        this.state = new input_state_group_1.IkeInputStateGroup();
        this.designer = designer;
        this.field = field;
        this.state.isLabelShown = false;
        this.menu = new menu_1.MenuComponent({
            items: function () { return _this.viewMenuItems(); },
            className: form_info_panel_style_1.CSS.menu
        });
    }
    Object.defineProperty(FormFieldEditor.prototype, "isLocked", {
        get: function () {
            return form_field_lock_1.LOCKED_MODEL_POLE_FIELDS[this.field.id] === true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormFieldEditor.prototype, "isLabelable", {
        get: function () {
            switch (this.field.type) {
                case core_api_1.IkeFieldType.TEXT:
                case core_api_1.IkeFieldType.NUMBER:
                case core_api_1.IkeFieldType.SELECT_LIST:
                case core_api_1.IkeFieldType.NESTED_LIST:
                    return true;
                default:
                    return false;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormFieldEditor.prototype, "isCloneable", {
        get: function () {
            switch (this.field.type) {
                case core_api_1.IkeFieldType.DATE:
                case core_api_1.IkeFieldType.FORM:
                case core_api_1.IkeFieldType.NESTED_LIST:
                case core_api_1.IkeFieldType.NUMBER:
                case core_api_1.IkeFieldType.SELECT_LIST:
                case core_api_1.IkeFieldType.TEXT:
                case core_api_1.IkeFieldType.YES_NO:
                    return true;
                default:
                    return false;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormFieldEditor.prototype, "isStatusable", {
        get: function () {
            var validFieldTypes = [core_api_1.IkeFieldType.NESTED_LIST, core_api_1.IkeFieldType.SELECT_LIST];
            return this.field.isRoot && validFieldTypes.includes(this.field.type);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormFieldEditor.prototype, "isMapColorable", {
        get: function () {
            var validFieldTypes = [core_api_1.IkeFieldType.NESTED_LIST, core_api_1.IkeFieldType.SELECT_LIST];
            return this.field.isRoot && validFieldTypes.includes(this.field.type);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormFieldEditor.prototype, "isAddressable", {
        get: function () {
            var validFieldTypes = [core_api_1.IkeFieldType.TEXT, core_api_1.IkeFieldType.NUMBER];
            return validFieldTypes.includes(this.field.type);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormFieldEditor.prototype, "isRequirable", {
        get: function () {
            var invalidFieldTypes = [core_api_1.IkeFieldType.FORM, core_api_1.IkeFieldType.VERTICAL_SEPARATION, core_api_1.IkeFieldType.YES_NO, core_api_1.IkeFieldType.FILE_TOOL];
            return this.field.isRoot && !(invalidFieldTypes.includes(this.field.type));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormFieldEditor.prototype, "depth", {
        get: function () {
            var depth = 0;
            var parent = this.field;
            while (parent != null) {
                parent = parent.parent;
                depth += 1;
            }
            return depth;
        },
        enumerable: false,
        configurable: true
    });
    FormFieldEditor.prototype.deleteField = function () {
        var parent = this.field.parent;
        this.field.Mutator.delete();
        this.state.destroy();
        this.designer.setSelected(parent);
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'form:field:delete');
    };
    FormFieldEditor.prototype.addField = function () {
        var field = this.field;
        if (!core_shared_1.FormModelFieldSubForm.isSubForm(field)) {
            return;
        }
        var newField = field.createField(core_api_1.IkeFieldType.TEXT);
        newField.Mutator.adminOnly(field.adminOnly);
        newField.Mutator.collector(field.collector);
        newField.Mutator.required(field.required);
        newField.Mutator.annotationLabelFieldId(field.annotationLabelFieldId);
        newField.Mutator.clearanceThresholdInMeters(field.clearanceThresholdInMeters);
        this.designer.setSelected(newField);
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'form:tree:add', core_api_1.IkeFieldType.TEXT);
    };
    FormFieldEditor.prototype.changeFieldType = function (type) {
        var originalType = this.field.type;
        if (type === originalType) {
            return;
        }
        if (core_shared_1.FormModelFieldSelectList.isSelectList(this.field) && this.field.options != null && this.field.options.length > 1) {
            notification_service_1.NotificationService.warn({ key: i18n_1.T.FORM_FIELD_CANNOT_CHANGE });
            return;
        }
        if (core_shared_1.FormModelFieldNestedList.isNestedList(this.field) && this.field.options != null && this.field.options.values.length > 0) {
            notification_service_1.NotificationService.warn({ key: i18n_1.T.FORM_FIELD_CANNOT_CHANGE });
            return;
        }
        if (core_shared_1.FormModelFieldSubForm.isSubForm(this.field) && this.field.fields != null && this.field.fields.length > 0) {
            notification_service_1.NotificationService.warn({ key: i18n_1.T.FORM_FIELD_CANNOT_CHANGE });
            return;
        }
        var parent = this.field.parent;
        var index = parent.getFieldIndex(this.field.id);
        var newField = parent.Mutator.create(type, null, index);
        newField.Mutator.displayName(this.field.displayName);
        newField.Mutator.collector(this.field.collector);
        newField.Mutator.adminOnly(this.field.adminOnly);
        newField.Mutator.annotationLabelFieldId(this.field.annotationLabelFieldId);
        newField.Mutator.clearanceThresholdInMeters(this.field.clearanceThresholdInMeters);
        if (newField.isCloneable) {
            newField.Mutator.cloneable(this.field.cloneable);
        }
        this.field.Mutator.delete();
        this.state.destroy();
        this.designer.setSelected(newField);
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'form:field:change-type', "".concat(originalType, " -> ").concat(type));
    };
    /** View the field as a tree */
    FormFieldEditor.prototype.viewTree = function () {
        return form_field_tree_view_1.FormFieldTreeView.view(this);
    };
    /** View the field as a info panel */
    FormFieldEditor.prototype.viewInfo = function () {
        if (this.designer.isEditing) {
            return this._viewInfoRW();
        }
        return this._viewInfoRO();
    };
    // Additional information view for children;
    FormFieldEditor.prototype.viewInfoRW = function () { return null; };
    FormFieldEditor.prototype.viewInfoRO = function () { return null; };
    FormFieldEditor.prototype._viewInfoRO = function () {
        return (0, mithril_1.m)('div', { className: form_info_panel_style_1.CSS.container }, [
            this.viewTitle(),
            this.viewOptions(),
            this.viewInfoRO()
        ]);
    };
    FormFieldEditor.prototype._viewInfoRW = function () {
        return (0, mithril_1.m)('div', { className: form_info_panel_style_1.CSS.container }, [
            this.viewFieldMove(),
            this.viewTitle(),
            this.viewOptions(),
            this.viewInfoRW()
        ]);
    };
    FormFieldEditor.prototype.viewTitle = function () {
        return (0, mithril_1.m)('div', { className: "".concat(form_info_panel_style_1.CSS.section.container) }, [
            input_1.Input.view(this.getTitleState()),
            this.viewFieldTypeButton(),
            this.viewFieldDeleteButton()
        ]);
    };
    FormFieldEditor.prototype.viewFieldTypeButton = function () {
        return (0, mithril_1.m)('div', { className: form_info_panel_style_1.CSS.container }, [
            (0, mithril_1.m)('button', { className: "mdl-button ".concat(form_info_panel_style_1.CSS.type), title: (0, i18n_1.Translate)(i18n_1.T.FORM_FIELD_TYPE), disabled: this.isLocked, onclick: this.menu.show }, [,
                form_palette_1.FormDesignerPalette.viewIcon(this.field.type),
                form_palette_1.FormDesignerPalette.translate(this.field.type),
                icon_1.Icon.view(icons_1.MaterialIcon.KEY_DOWN)
            ]),
            this.menu.view()
        ]);
    };
    FormFieldEditor.prototype.viewFieldDeleteButton = function () {
        var _this = this;
        if (!this.designer.isEditing || this.isLocked) {
            return null;
        }
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.DELETE, {
            title: i18n_1.T.FORM_FIELD_DELETE,
            onclick: function () { return _this.confirmDeleteField(); }
        });
    };
    FormFieldEditor.prototype.viewOptions = function () {
        var canSetAdminOnly = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
        var canHideFields = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_HIDE_FIELD)
            || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
        var canSetStatusProperty = (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE) || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_SORT_STATUS)) && this.isStatusable;
        var canSetMapColorProperty = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) && this.isMapColorable;
        var canSetAddressProperty = this.isAddressable && (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE) ||
            services_1.Services.UserProfile.isDepartmentAdmin(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId)));
        if (!this.isLabelable &&
            !this.isCloneable &&
            !canHideFields &&
            !canSetAdminOnly &&
            !canSetStatusProperty &&
            !canSetMapColorProperty &&
            !canSetAddressProperty) {
            return null;
        }
        var canSetRequiredProperty = this.isRequirable && services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
        var isRoot = this.field.isRoot;
        var canSecondaryLabel = (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_SECONDARY_LABEL) || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)) && this.isLabelable && isRoot;
        return (0, mithril_1.m)('div', { className: "".concat(form_info_panel_style_1.CSS.section.container, " ").concat(form_info_panel_style_1.CSS.section.final) }, [
            this.isLabelable ? this.viewOption(i18n_1.T.FORM_OPTION_LABEL, input_checkbox_1.CheckBox.view(this.getLabelableState()), (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_LABEL_TITLE, { isRoot: isRoot })) : null,
            canSecondaryLabel ? this.viewOption(i18n_1.T.FORM_OPTION_SECONDARY_LABEL, input_checkbox_1.CheckBox.view(this.getSecondarylabelableState()), (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_SECONDARY_LABEL)) : null,
            this.isCloneable ? this.viewOption(i18n_1.T.FORM_OPTION_CLONEABLE, input_checkbox_1.CheckBox.view(this.getCloneableState()), (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_CLONEABLE_TITLE)) : null,
            canHideFields ? this.viewOption(i18n_1.T.FORM_OPTION_HIDE, input_checkbox_1.CheckBox.view(this.getHiddenState()), (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_HIDE_TITLE)) : null,
            canSetAdminOnly ? this.viewOption(i18n_1.T.FORM_OPTION_ADMIN_ONLY, input_checkbox_1.CheckBox.view(this.getAdminOnlyState()), (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_ADMIN_ONLY_TITLE)) : null,
            canSetStatusProperty ? this.viewOption(i18n_1.T.FORM_OPTION_STATUS, input_checkbox_1.CheckBox.view(this.getStatusState()), (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_STATUS_TITLE)) : null,
            canSetMapColorProperty ? this.viewOption(i18n_1.T.FORM_OPTION_MAP_COLOR, input_checkbox_1.CheckBox.view(this.getMapColorState()), (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_MAP_COLOR_TITLE)) : null,
            canSetRequiredProperty ? this.viewOption(i18n_1.T.FORM_OPTION_REQUIRED, input_checkbox_1.CheckBox.view(this.getRequiredState()), (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_REQUIRED_TITLE)) : null,
            canSetAddressProperty ? this.viewOption(i18n_1.T.FORM_OPTION_ADDRESS, input_checkbox_1.CheckBox.view(this.getAddressState()), (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_ADDRESS_TITLE)) : null
        ]);
    };
    FormFieldEditor.prototype.viewOption = function (name, value, title) {
        return (0, mithril_1.m)('div', { className: form_info_panel_style_1.CSS.input.container, title: title }, [
            (0, mithril_1.m)('div', { className: form_info_panel_style_1.CSS.input.title }, (0, i18n_1.Translate)(name)),
            (0, mithril_1.m)('div', { className: form_info_panel_style_1.CSS.input.value }, value)
        ]);
    };
    FormFieldEditor.prototype.confirmDeleteField = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, metaStatus, metaMapColor, metaAddressLookup;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, modal_service_1.ModalService.open({
                            title: (0, i18n_1.Translate)(i18n_1.T.FORM_FIELD_DELETE_TITLE),
                            content: (0, i18n_1.Translate)(i18n_1.T.FORM_FIELD_DELETE_CONFIRM, { name: this.field.displayName || form_palette_1.FormDesignerPalette.translate(this.field.type) }),
                            hasCancel: true,
                            okName: i18n_1.T.FORM_FIELD_DELETE
                        })];
                    case 1:
                        result = _a.sent();
                        if (result.ok) {
                            // add stateValue.displayName to empty fields
                            // to handle the state issue
                            if (this.field.stateValue.displayName === '') {
                                this.field.stateValue.displayName = 'empty';
                            }
                            metaStatus = this.field.getForm().metadata.getStatusField();
                            if (metaStatus && metaStatus.id === this.field.id) {
                                this.field.getForm().metadata.removeStatusField(this.field);
                            }
                            metaMapColor = this.field.getForm().metadata.getMapColorField();
                            if (metaMapColor && metaMapColor.id === this.field.id) {
                                this.field.getForm().metadata.removeMapColorField(this.field);
                            }
                            metaAddressLookup = this.field.getForm().metadata.getAddressLookupField();
                            if (metaAddressLookup && metaAddressLookup.id === this.field.id) {
                                this.field.getForm().metadata.removeAddressLookupField(this.field);
                            }
                            this.field.Mutator.delete();
                            this.state.destroy();
                            this.designer.setSelected(this.field.parent);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FormFieldEditor.prototype.viewFieldMove = function () {
        var _this = this;
        if (!this.designer.isEditing || this.field.parent == null) {
            return null;
        }
        var index = this.field.parent.getFieldIndex(this.field.id);
        var fieldCount = this.field.parent.fields.length;
        var isFirst = index === 0;
        var isLast = index === fieldCount - 1;
        return (0, mithril_1.m)('div', { className: form_info_panel_style_1.CSS.move }, [
            image_button_1.ImageButton.view(icons_1.MaterialIcon.KEY_UP, {
                onclick: function () {
                    if (isFirst) {
                        return;
                    }
                    _this.field.Mutator.moveUp();
                    _this.designer.setScrollToField(_this.field);
                    services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'form:field:move-up', _this.field.id);
                },
                title: i18n_1.T.FORM_FIELD_MOVE_UP,
                disabled: isFirst,
                className: image_button_1.ImageButton.CSS.isSmall
            }),
            image_button_1.ImageButton.view(icons_1.MaterialIcon.KEY_DOWN, {
                onclick: function () {
                    if (isLast) {
                        return;
                    }
                    _this.field.Mutator.moveDown();
                    _this.designer.setScrollToField(_this.field);
                    services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'form:field:move-down', _this.field.id);
                },
                title: i18n_1.T.FORM_FIELD_MOVE_DOWN,
                disabled: isLast,
                className: image_button_1.ImageButton.CSS.isSmall
            })
        ]);
    };
    FormFieldEditor.prototype.viewMenuItems = function () {
        var _this = this;
        var subformDepth = this.depth - 1;
        var items = [];
        var _loop_1 = function (key) {
            var option = form_palette_1.FIELD_TYPE_DISPLAY[key];
            var maxDepthReached = option.maxDepth != null && option.maxDepth < subformDepth;
            var hasPermission = services_1.Services.User.hasFormPermission(key);
            if (hasPermission) {
                items.push({
                    view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(option.title), option.icon),
                    disabled: key === this_1.field.type || maxDepthReached || !hasPermission,
                    action: function () { return _this.changeFieldType(key); }
                });
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = Object.keys(form_palette_1.FIELD_TYPE_DISPLAY); _i < _a.length; _i++) {
            var key = _a[_i];
            _loop_1(key);
        }
        return items;
    };
    FormFieldEditor.prototype.getTitleState = function () {
        var _this = this;
        var displayState = this.state.get('display');
        if (displayState == null) {
            displayState = this.state.child(i18n_1.T.FORM_FIELD_DISPLAY_NAME, 'display');
            displayState.isLabelShown = true;
            displayState.isRequired = true;
            displayState.onValue(function (val) { return _this.field.Mutator.displayName(val); });
            displayState.setValue(this.field.displayName);
        }
        displayState.readOnly = this.isLocked || !this.designer.isEditing;
        displayState.setAutoFocus(true);
        return displayState;
    };
    FormFieldEditor.prototype.getLabelableState = function () {
        var _this = this;
        return {
            isSelected: function () { return _this.field.title; },
            setSelected: function (val) {
                _this.setTitle(val);
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'form:field:label', String(val));
            },
            isDisabled: !this.designer.isEditing
        };
    };
    FormFieldEditor.prototype.getSecondarylabelableState = function () {
        var _this = this;
        return {
            isSelected: function () { return _this.field.subtitle; },
            setSelected: function (val) {
                _this.setSubtitle(val);
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'form:field:secondarylabel', String(val));
            },
            isDisabled: !this.designer.isEditing
        };
    };
    FormFieldEditor.prototype.getHiddenState = function () {
        var _this = this;
        return {
            isSelected: function () { return _this.field.collector === core_api_1.IkeCollectorType.OFFICE || _this.isParentHidden(); },
            setSelected: function (val) {
                _this.setHidden(val);
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'form:field:hidden', String(val));
            },
            isDisabled: !this.designer.isEditing || this.isParentHidden()
        };
    };
    FormFieldEditor.prototype.getAdminOnlyState = function () {
        var _this = this;
        return {
            isSelected: function () { return _this.field.adminOnly === true || _this.isParentAdminOnly(); },
            setSelected: function (val) {
                _this.setAdminOnly(val);
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'form:field:adminOnly', String(val));
            },
            isDisabled: !this.designer.isEditing || this.isParentAdminOnly()
        };
    };
    FormFieldEditor.prototype.getCloneableState = function () {
        var _this = this;
        return {
            isSelected: function () { return _this.field.cloneable != null && _this.field.cloneable !== core_api_1.IkeCloneable.NONE; },
            setSelected: function (val) {
                _this.setCloneable(val);
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'form:field:cloneable', String(val));
            },
            isDisabled: !this.designer.isEditing || !this.isParentCloneable()
        };
    };
    FormFieldEditor.prototype.getStatusState = function () {
        var _this = this;
        return {
            isSelected: function () { return _this.field.isStatusField; },
            setSelected: function (val) {
                _this.setStatusField(val);
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'form:field:status', String(val));
            },
            isDisabled: !this.designer.isEditing || this.isParentHidden()
        };
    };
    FormFieldEditor.prototype.getMapColorState = function () {
        var _this = this;
        return {
            isSelected: function () { return _this.field.isMapColorField; },
            setSelected: function (val) {
                _this.setMapColorField(val);
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'form:field:mapcolor', String(val));
            },
            isDisabled: !this.designer.isEditing || this.isParentHidden()
        };
    };
    FormFieldEditor.prototype.getRequiredState = function () {
        var _this = this;
        return {
            isSelected: function () { return _this.field.required === true; },
            setSelected: function (val) {
                _this.setRequired(val);
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'form:field:required', String(val));
            },
            isDisabled: !this.designer.isEditing || this.isRequiredDisabled()
        };
    };
    FormFieldEditor.prototype.getAddressState = function () {
        var _this = this;
        return {
            isSelected: function () { return _this.field.isAddressLookupField; },
            setSelected: function (val) {
                _this.setAddressLookupField(val);
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'form:field:address', String(val));
            },
            isDisabled: !this.designer.isEditing || this.isParentHidden()
        };
    };
    FormFieldEditor.prototype.isParentCloneable = function () {
        if (this.field.parent.parent == null) {
            return true;
        }
        return this.field.parent.cloneable != null && this.field.parent.cloneable !== core_api_1.IkeCloneable.NONE;
    };
    FormFieldEditor.prototype.isParentAdminOnly = function () {
        if (this.field.parent.parent == null) {
            return false;
        }
        return this.field.parent.adminOnly;
    };
    FormFieldEditor.prototype.isParentHidden = function () {
        if (this.field.parent.parent == null) {
            return false;
        }
        return this.field.parent.collector === core_api_1.IkeCollectorType.OFFICE;
    };
    FormFieldEditor.prototype.isRequiredDisabled = function () {
        var adminField = this.field.adminOnly;
        var hiddenField = this.field.collector === core_api_1.IkeCollectorType.OFFICE;
        return (adminField || hiddenField);
    };
    FormFieldEditor.prototype.setTitle = function (title) {
        this.field.Mutator.title(title);
    };
    FormFieldEditor.prototype.setSubtitle = function (subtitle) {
        this.field.Mutator.subtitle(subtitle);
    };
    FormFieldEditor.prototype.setHidden = function (hidden) {
        if (hidden) {
            this.field.Mutator.collector(core_api_1.IkeCollectorType.OFFICE);
            this.field.Mutator.required(false);
        }
        else {
            this.field.Mutator.collector(core_api_1.IkeCollectorType.ALL);
        }
    };
    FormFieldEditor.prototype.setAdminOnly = function (adminOnly) {
        this.field.Mutator.adminOnly(adminOnly);
        if (adminOnly) {
            this.field.Mutator.required(false);
        }
    };
    FormFieldEditor.prototype.setCloneable = function (cloneable) {
        if (cloneable) {
            this.field.Mutator.cloneable(core_api_1.IkeCloneable.FIRST);
        }
        else {
            this.field.Mutator.cloneable(core_api_1.IkeCloneable.NONE);
        }
    };
    FormFieldEditor.prototype.setAnnotationLabelFieldId = function (fieldId) {
        this.field.Mutator.annotationLabelFieldId(fieldId);
    };
    FormFieldEditor.prototype.setClearanceThresholdInMeters = function (clearanceThresholdInMeters) {
        this.field.Mutator.clearanceThresholdInMeters(clearanceThresholdInMeters);
    };
    FormFieldEditor.prototype.setStatusField = function (useAsStatus) {
        this.field.Mutator.isStatusField(useAsStatus);
    };
    FormFieldEditor.prototype.setMapColorField = function (useAsMapColor) {
        this.field.Mutator.isMapColorField(useAsMapColor);
    };
    FormFieldEditor.prototype.setRequired = function (required) {
        this.field.Mutator.required(required);
    };
    FormFieldEditor.prototype.setAddressLookupField = function (address) {
        this.field.Mutator.isAddressLookupField(address);
    };
    tslib_1.__decorate([
        mobx_1.action.bound
    ], FormFieldEditor.prototype, "deleteField", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], FormFieldEditor.prototype, "addField", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], FormFieldEditor.prototype, "changeFieldType", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormFieldEditor.prototype, "setTitle", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormFieldEditor.prototype, "setSubtitle", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormFieldEditor.prototype, "setHidden", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormFieldEditor.prototype, "setAdminOnly", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormFieldEditor.prototype, "setCloneable", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormFieldEditor.prototype, "setAnnotationLabelFieldId", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormFieldEditor.prototype, "setClearanceThresholdInMeters", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormFieldEditor.prototype, "setStatusField", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormFieldEditor.prototype, "setMapColorField", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormFieldEditor.prototype, "setRequired", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormFieldEditor.prototype, "setAddressLookupField", null);
    return FormFieldEditor;
}());
exports.FormFieldEditor = FormFieldEditor;
//# sourceMappingURL=form.field.editor.js.map